import { render, staticRenderFns } from "./customergroupreport.vue?vue&type=template&id=03f56420&"
import script from "./customergroupreport.vue?vue&type=script&lang=js&"
export * from "./customergroupreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports